import { Button } from "@mui/material";
import "./CallToActionButton.css";
import {
  BUTTON_STYLES,
  CALL_TO_ACTION_BUTTON_STYLES,
} from "../../../utils/constants";
import { useTranslation } from "react-i18next";

export default function CallToActionButton({ attachmentBlock, buttonStyles }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "callToActionBlock",
  });
  return (
    <Button
      sx={{
        ...BUTTON_STYLES,
        ...CALL_TO_ACTION_BUTTON_STYLES,
        ...buttonStyles,
      }}
      variant="contained"
      className="call-to-action-button"
    >
      <a
        className="call-to-action-button__link"
        href="https://linktr.ee/active_generation"
        target="_blank"
        rel="noreferrer"
      >
        {t(`joinOrganizationButton${attachmentBlock}`)}
      </a>
    </Button>
  );
}
